const threeColumn = {
  displayField: 'header',
  name: 'Three Column',
  description: '',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [
        { size: { min: null, max: 80 }, message: 'Max 80 Characters ' }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'people',
      name: 'People',
      type: 'Array',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    }
  ],
  sys: {
    id: 'threeColumn',
    version: 23,
    updatedAt: '2023-08-03T14:40:55.603Z'
  }
};
export default threeColumn;